/**
 * @generated SignedSource<<67db602920091c18b3fcf4faf82481d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightInfoFullSegment_segment$data = {
  readonly arrivalAirportCode: string;
  readonly arrivalDatetime: string;
  readonly departAirportCode: string;
  readonly departDatetime: string;
  readonly " $fragmentType": "FlightInfoFullSegment_segment";
};
export type FlightInfoFullSegment_segment$key = {
  readonly " $data"?: FlightInfoFullSegment_segment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightInfoFullSegment_segment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightInfoFullSegment_segment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalDatetime",
      "storageKey": null
    }
  ],
  "type": "FlightSegment",
  "abstractKey": null
};

(node as any).hash = "ef27f4d468ebd9625b5595f58dba7566";

export default node;
